import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSignState } from 'context/signview';
import { parseDate } from 'utils';

export default function BlockchainTab() {
    const { t } = useTranslation();
    const { contract } = useSignState();
    const creationDate = new Date().toISOString();
    const events = useMemo(() => [
        {
            title: t('blockchain.registered'),
            subtitle: creationDate ? parseDate(creationDate, 'Pp') : '',
            status: creationDate ? 'executed' : 'executing'
        },

        // {
        //     title: t("blockchain.toFund"),
        //     subtitle: signAll || isFunded ? parseDate(fundDate, 'Pp') : '',
        //     status: signAll || isFunded ? 'executed' : 'execute'
        // },

        // {
        //     title: t("blockchain.funded"),
        //     subtitle: signAll || isFunded ? parseDate(fundDate, 'Pp') : '',
        //     status: signAll || isFunded ? 'executed' : 'executing'
        // },

        // {
        //     title: t("blockchain.waiting_sign"),
        //     subtitle: signAll ? parseDate(signAll, 'Pp') : '',
        //     status: signAll ? 'executed' : isFunded ? 'execute' : 'executing'
        // },

        // {
        //     title: t("blockchain.signed_by_all"),
        //     subtitle: signAll ? parseDate(signAll, 'Pp') : '',
        //     status: signAll ? 'executed' : 'executing'
        // }
    ], [t]);

    return (
        <div id="blockchain" className="tab-pane active">
            <div className="blockchain">
                <div className="p-2">
                    <h4>{t('blockchain.sidebar_title')}</h4>
                    <span className="text-justify">{t('blockchain.sidebar_subtitle')}</span>

                    <div className="mt-4">
                        <button className="btn btn-block btn-white pointer"
                            data-action="open-my-wallet">{t('blockchain.my_wallet')}</button>
                    </div>
                    <h4 className="mt-5">{t('blockchain.address')}</h4>
                    <div className="text-center">
                        <img src={contract.addressQR} alt="" />
                        <small className="text-x-small">
                            <a
                                href={`${process.env.REACT_APP_ETHERSCAN_URL}/address/${contract._address}`}
                                target="_blank"
                                rel="noreferrer">
                                {contract._address}
                            </a>
                        </small>
                    </div>
                    <h4 className="mt-5">{t('blockchain.timeline')}</h4>
                    <div className="mt-3">
                        <div className="timeline">
                            {events.forEach((event) => (
                                <div className="timeline-item {{status}}">
                                    {event.status === 'executed' &&
                                        <div className='timeline-executed'>
                                            <i className="fas fa-check"></i>
                                        </div>}
                                    <h1> {event.title}</h1>
                                    <p>
                                        {event.subtitle}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}